<template>
  <CRow class="get_started">
    <CCol cols="12" xl="12" lg="12" md="12" sm="12">
      <div class="d-flex content-center flex-column h-100">
        <i class="fas fa-box-open"></i>
        <p v-html="content"></p>
      </div>
    </CCol>    
  </CRow>
</template>

<script>

export default {
  name: 'getStarted',
  props: ['content']
}
</script>

<style lang="scss">
.get_started p {
  font-size: 1.2em;
  line-height: 30px;
}

.get_started i {
  font-size: 3em;
  margin-bottom: 10px;
}
</style>